import { apiRequest } from '../../lib/api';
import type {
  AllocationResult,
  FranchiseDashboard,
  FranchiseOcOverview,
  FranchiseOcRequest,
  FranchiseStore,
} from './types';

function post<T>(path: string, payload: unknown): Promise<T> {
  return apiRequest<T>(path, { method: 'POST', idempotent: true, body: JSON.stringify(payload) });
}

export const franchiseApi = {
  dashboard: () => apiRequest<FranchiseDashboard>('/api/v1/franchise/dashboard'),
  stores: () => apiRequest<{ rows: FranchiseStore[] }>('/api/v1/franchise/stores').then((r) => r.rows),
  oc: () => apiRequest<FranchiseOcOverview>('/api/v1/franchise/oc'),

  requestOc: (input: { amount: number; amountKrw: number | null; reason: string; storeId: string | null }) =>
    post<FranchiseOcRequest>('/api/v1/franchise/oc-requests', {
      request_type: 'issue',
      amount: input.amount,
      amount_krw: input.amountKrw,
      reason: input.reason.trim(),
      ...(input.storeId ? { store_id: input.storeId } : {}),
    }),
  cancelOcRequest: (id: string) =>
    post<{ request_id: string; status: 'cancelled' }>(`/api/v1/franchise/oc-requests/${id}/cancel`, {}),
  allocateOc: (input: { storeId: string; amount: number; reason: string }) =>
    post<AllocationResult>(`/api/v1/franchise/stores/${input.storeId}/oc-allocations`, {
      amount: input.amount,
      reason: input.reason.trim(),
    }),
  setStoreAdminStatus: (input: { id: string; status: 'active' | 'suspended'; reason: string }) =>
    apiRequest<{ id: string; status: string }>(`/api/v1/franchise/store-admins/${input.id}/status`, {
      method: 'PATCH',
      idempotent: true,
      body: JSON.stringify({ status: input.status, reason: input.reason.trim() }),
    }),
};
